<template>
  <div>
    <component :config="config" :is="currentComponent"></component>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "HomeView",
  data() {
    return {
      config: {},
    };
  },
  components: {
    webPage: () => import("./webPage.vue"),
    mPage: () => import("./mPage.vue"),
    mPageNew: () => import("./mPageNew.vue"), //新版小红书落地页
  },
  computed: {
    app_download_url() {
      if (
        Array.isArray(this.config.app_download_url) &&
        this.config.app_download_url.length > 0
      ) {
        return this.config.app_download_url[0].url;
      }
      return "";
    },
    currentComponent() {
      return this.isMobile() ? "mPageNew" : "mPage";
    },
  },
  methods: {
    isMobile() {
      const userAgent = navigator.userAgent.toLowerCase();
      return /android|iphone|ipad|ipod|windows phone|blackberry|opera mini|iemobile|mobile/i.test(
        userAgent
      );
    },
  },
  created() {},
};
</script>
